<div class="gitlab-issue-header">
  <svg class="s16x32"><use xlink:href="#issue_open" /></svg>
  <h3 class="title">   
    {{text.title}}
  </h3>
</div>
